import { render, staticRenderFns } from "./edit-infoall.vue?vue&type=template&id=f3e52f80"
import script from "./edit-infoall.vue?vue&type=script&lang=ts"
export * from "./edit-infoall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports